import React from 'react';
import { observer } from 'mobx-react';
// import moment from 'moment';
import store from '../../../../stores/store';
import {
    GROUP_HOVER_COLOR_VAR,
    DEFAULT_COMPANY_COLOR,
    VOTE_PENDING,
    VOTE_OPEN,
} from '../../../../helpers/constants';
import { getColor, setColor, getFormattedTime } from '../../../../helpers/utils';
import CompanyLogoPlaceholder from '../../../../assets/images/boardtrac_plus_logo.svg';

const GroupCard = observer(
    class GroupCard extends React.Component {
        css = DEFAULT_COMPANY_COLOR;

        mouseOver = () => {
            this.css = getColor(GROUP_HOVER_COLOR_VAR);
            let color = store.companies.getColorByIndex(this.props.details.groupsIndex);
            setColor(GROUP_HOVER_COLOR_VAR, color);
        };

        mouseOut = () => {
            setColor(GROUP_HOVER_COLOR_VAR, this.css);
        };

        onClick = e => {
            if (this.props.onClick) {
                this.props.onClick(this.props.details.GroupId, this.props.details.groupsIndex, e);
            }
        };

        render() {
            //
            const { details, selected, logo } = this.props;
            let cardClass = 'card' + (selected ? ' selected' : '');
            let upcoming = !store.meetings.loading
                ? store.meetings.getUpcomingMeeting(details.company.InstanceId, details.GroupId)
                : null;
            const numberOfActiveVotes = store.votes
                .votesFilteredByGroup(details.company.InstanceId, details.GroupId)
                .filter(vote => {
                    // console.log("vote: ", vote)
                    return (
                        (vote.VotePermissions & 16) === 16 &&
                        vote.CurrentCastVote === VOTE_PENDING &&
                        vote.VoteStatus === VOTE_OPEN
                    );
                }).length;
            // console.log("numberOfActiveVotes:", numberOfActiveVotes)

            return (
                <div
                    className=""
                    onClick={this.onClick}
                    onMouseOver={this.mouseOver}
                    onMouseOut={this.mouseOut}
                    onMouseDown={this.mouseDown}
                    onMouseUp={this.onMouseUp}
                >
                    <div className={cardClass}>
                        {details.hasNewItems && <span className="badge badge-primary">New</span>}
                        <div className="card-block">
                            <div className="card-title">
                                <h5>{details.GroupName}</h5>
                            </div>
                            <div className="d-flex flex-row card-text">
                                <div className="col d-flex flex-column company-logo">
                                    <img
                                        className="my-auto mx-auto img-fluid"
                                        src={logo ? logo : CompanyLogoPlaceholder}
                                        alt={details.GroupName}
                                    />
                                </div>
                                <div className="col small text-muted text-center meeting-padding">
                                    <div className="col">{upcoming && 'Next meeting'}</div>
                                    <div className="col">{upcoming && upcoming.date}</div>
                                    <div className="col">{upcoming && upcoming.time}</div>
                                </div>
                                <div className="vertical" />
                                <div className="col small text-muted text-center vote-padding">
                                    <div className="col">Active votes</div>
                                    <div className="col">{numberOfActiveVotes}</div>
                                </div>
                            </div>
                            <div className="card-footer small">
                                <span className="small text-muted">
                                    Last modified: {getFormattedTime(details.lastActivity)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    },
);

export default GroupCard;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Group/components/GroupCard.js